<nav class="bottom-navigation">
  <a
    *ngFor="let navOption of navOptions"
    [routerLink]="navOption.routerLink"
    routerLinkActive="active"
    [id]="'bottom-navigation__' + navOption.label"
    class="bottom-navigation__link"
    (click)="closeNavigation()"
  >
    <div class="bottom-navigation__link--icon">
      <ui-svg-icon
        [svgId]="navOption.svgId"
        [iconClassName]="navOption.svgIconClassName"
      ></ui-svg-icon>
    </div>
    <div class="bottom-navigation__link--text">{{ navOption.label }}</div>
  </a>
</nav>
